module.exports = __webpack_public_path__ + "static/media/notes.fba81fba.jpg";